<script>
    import { createEventDispatcher } from 'svelte'
    import Flatpickr from '../../components/Flatpicker/Flatpicker.svelte'

    export let value

    const dispatch = createEventDispatcher ();


    let timer   = null,
        options = {
            inline: true,
            enableTime: true,
            dateFormat: "D d/m/Y H:m",
            time_24hr: true,
            onValueUpdate: (dates) => {
                if (timer) {
                    clearTimeout (timer)
                    timer = null
                }

                timer = setTimeout (() => {
                    // console.log ('datepicked')
                    value = dates[0];
                    dispatch ('datepicked', { date: value })
                }, 100)
            }
            // minDate: "today"
        }
</script>

<style>
    .ChooseDate :global(.flatpickr-input) {
        position: absolute;
        right: 10000px;
    }
    .ChooseDate :global(.flatpickr-calendar) {
        background-color: unset;
        box-shadow: none;
        border-radius: 0;
    }
    .ChooseDate :global(.flatpickr-day) {
        border-radius: 5px;
    }
    .ChooseDate :global(.flatpickr-calendar), 
    .ChooseDate :global(.flatpickr-days) {
        width: 260px;
    }
    .ChooseDate :global(.dayContainer) {
        width: 260px;
        min-width: 260px;
        max-width: 260px;
    }
    .ChooseDate :global(.flatpickr-months svg) {
        vertical-align: top;
    }
    .ChooseDate :global(.flatpickr-current-month) {
        font-size: 16px;
    }
    .ChooseDate :global(.flatpickr-current-month select), 
    .ChooseDate :global(.flatpickr-current-month input) {
        font-weight: 600;
        color: #465d6f;
    }
</style>

<div class="ChooseDate">
    <Flatpickr {options} {value} />
</div>